'use client';

import { c as _c } from "react/compiler-runtime";
import { handleVisibleHeader } from '@lib/store/slices/ComponentsSlice';
import { ScrollSmoother } from '@lib/tools/gsap-init';
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { getScrollToTopDecision } from '../../../lib/tools/scroll/scrollToTopRules.js';
export function ScrollToTop() {
  const $ = _c(5);
  const pathname = usePathname();
  const prevPathnameRef = useRef(null);
  const dispatch = useDispatch();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  let t1;
  let t2;
  if ($[1] !== dispatch || $[2] !== pathname) {
    t1 = () => {
      const prev = prevPathnameRef.current;
      prevPathnameRef.current = pathname;
      const {
        skipScrollToTop,
        forceTopOnLoad,
        forceShowHeaderOnEnterNews
      } = getScrollToTopDecision(pathname, prev);
      if (skipScrollToTop && !forceTopOnLoad) {
        return;
      }
      const scrollToTop = _temp2;
      const forceShowHeader = () => {
        dispatch(handleVisibleHeader(true));
        setTimeout(() => dispatch(handleVisibleHeader(true)), 0);
      };
      if (forceShowHeaderOnEnterNews) {
        dispatch(handleVisibleHeader(true));
      }
      scrollToTop();
      requestAnimationFrame(() => {
        scrollToTop();
        setTimeout(scrollToTop, 0);
        if (forceTopOnLoad || forceShowHeaderOnEnterNews) {
          forceShowHeader();
        }
      });
    };
    t2 = [pathname, dispatch];
    $[1] = dispatch;
    $[2] = pathname;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  return null;
}
function _temp2() {
  const smoother = ScrollSmoother.get?.();
  if (smoother) {
    smoother.scrollTo(0, {
      duration: 0
    });
    return;
  }
  window.scrollTo(0, 0);
}
function _temp() {
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }
}